var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolidHorizLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5, .cls-7 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5, .cls-7 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 0.67px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.33px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-6 {\r\n        font-size: 8.75px;\r\n        fill: #000;\r\n        stroke-width: 0px\r\n        font-family: ArialMT, Arial;\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke-width: 0.8px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconSolidHorizLayer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Solid_Horizontal",
    "data-name": "Solid Horizontal"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124 123.02 186.49 88.01 98.78 56.43 36.28 91.44 124 123.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124 128.6 186.49 93.59 186.49 88.01 124 123.02 124 128.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124 128.6 124 123.02 36.28 91.44 36.28 97.02 124 128.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 186.49,
    y1: 93.59,
    x2: 123.99,
    y2: 128.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.99,
    y1: 128.6,
    x2: 36.28,
    y2: 97.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.28,
    y1: 91.44,
    x2: 123.99,
    y2: 123.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 123.99,
    y1: 123.02,
    x2: 186.49,
    y2: 88.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 186.49,
    y1: 88.01,
    x2: 98.78,
    y2: 56.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 98.78,
    y1: 56.43,
    x2: 36.28,
    y2: 91.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.28,
    y1: 97.02,
    x2: 36.28,
    y2: 91.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 186.49,
    y1: 88.01,
    x2: 186.49,
    y2: 93.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 123.99,
    y1: 123.02,
    x2: 123.99,
    y2: 128.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "139.74 131.38 139.78 132.18 140.36 132.72 141.16 132.69 141.7 132.1 141.66 131.3 141.08 130.76 140.28 130.8 139.74 131.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "139.74 131.38 139.78 132.18 140.36 132.72 141.16 132.69 141.7 132.1 141.66 131.3 141.08 130.76 140.28 130.8 139.74 131.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "139.74 131.38 139.78 132.18 140.36 132.72 141.16 132.69 141.7 132.1 141.66 131.3 141.08 130.76 140.28 130.8 139.74 131.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 156.5,
    y1: 137.53,
    x2: 169.53,
    y2: 137.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 140.72,
    y1: 131.74,
    x2: 156.5,
    y2: 137.53
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(172.65 140.65)"
  }, "Thickness"), /*#__PURE__*/React.createElement("polygon", {
    points: "144.67 104.79 144.33 105.51 144.59 106.26 145.32 106.6 146.07 106.33 146.41 105.61 146.14 104.86 145.42 104.52 144.67 104.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "144.67 104.79 144.33 105.51 144.59 106.26 145.32 106.6 146.07 106.33 146.41 105.61 146.14 104.86 145.42 104.52 144.67 104.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "144.67 104.79 144.33 105.51 144.59 106.26 145.32 106.6 146.07 106.33 146.41 105.61 146.14 104.86 145.42 104.52 144.67 104.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 161.33,
    y1: 123.17,
    x2: 169.53,
    y2: 123.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 145.37,
    y1: 105.56,
    x2: 161.33,
    y2: 123.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(172.65 126.3)"
  }, "Material"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 140.78,
    y1: 125.34,
    x2: 140.78,
    y2: 138.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 140.78,
    y1: 134.64,
    x2: 139.16,
    y2: 132.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 140.78,
    y1: 134.64,
    x2: 142.4,
    y2: 137.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 140.78,
    y1: 134.64,
    x2: 144.03,
    y2: 135.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 140.78,
    y1: 134.64,
    x2: 127.24,
    y2: 129.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 140.78,
    y1: 129.06,
    x2: 139.16,
    y2: 126.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 140.78,
    y1: 129.06,
    x2: 142.4,
    y2: 131.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 140.78,
    y1: 129.06,
    x2: 144.03,
    y2: 130.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 140.78,
    y1: 129.06,
    x2: 127.24,
    y2: 124.19
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(36.38 162.25)"
  }, "Note: Materials with GWP defined per unit "), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(36.38 172.31)"
  }, "area will not take thickness into account in "), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(36.38 182.37)"
  }, "calculations.")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidHorizLayer);
export default __webpack_public_path__ + "static/media/IconSolidHorizLayer.fb71469198767ed5d8183b74694f3651.svg";
export { ForwardRef as ReactComponent };